import '@forest/native-diagnostics'

import { initializeNativeBridge } from '@forest/native-services'
import { language, resolvedAppVersion, shouldUseMockAPI } from './lib/params'
import { installInboundProbe, mark, observeBridge } from './lib/perf'
import { overwriteGetLocale, type Locale } from './paraglide/runtime'

// The first mark: the bundle has been fetched, parsed, and is executing.
// Everything before it on the timeline is navigation and resource loading.
mark('script:setup')

overwriteGetLocale(() => language as Locale)

if (!shouldUseMockAPI) {
  installInboundProbe()
  const bridge = initializeNativeBridge({
    appVersion: resolvedAppVersion,
    bifrost: { enableDebug: import.meta.env.MODE !== 'production' },
  })
  observeBridge(bridge)
  // App dismisses the native loading cover (pageReady) as it first renders,
  // right after this, before Shop bootstrap; the boot skeleton is the
  // loading UI from there (ADR 0048).
}
